import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    ReferenceInput,
    SelectInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { Chapters } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { STATUS } from '../../common/constants';
import SlugInput from '../../common/inputs/SlugInput';

const ChapterEdit = () => {
    let { programId, subjectId, chapterId } = useParams();
    if (!chapterId) {
        return <LoadingSection />;
    }
    return (
        <Edit
            mutationMode={'pessimistic'}
            title={<ChapterTitle />}
            redirect={() => {
                return `programs/${programId}/subjects/${subjectId}/chapters`;
            }}
            resource={'chapters'}
            id={chapterId}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <TextInput source="name" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <NumberInput
                    source="displayOrder"
                    type={'number'}
                    fullWidth
                    validate={[required(), minValue(0)]}
                />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUS}
                />
                <HTMLEditorInput
                    source={'description'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
            </SimpleForm>
        </Edit>
    );
};

const ChapterTitle = () => {
    const record = useRecordContext<Chapters>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.chapters.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default ChapterEdit;
